import moment from 'moment';

const formatDateMDY = (str) => {
    
    return str && moment(str).isValid() ? moment(str).format('MM-DD-YYYY') : '';
}

export { formatDateMDY};